import React from "react";
import PropTypes from "prop-types";
import { PortfolioWrapper } from "./style";
import {
	CloudinaryImage,
	Link,
	Text,
} from "@website-builder/ui/shared/elements";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";

const isB2U = process.env.GATSBY_BUSINESS_VERTICAL === "b2u";
const Portfolio = ({
	className = "",
	image,
	coverImage,
	title,
	subtitle,
	description,
	link,
	target,
	isDarkBackground,
	pageSection,
	linkColor,
	...restProps
}) => {
	return (
		<PortfolioWrapper
			className="portfolio"
			isLinkDarkBackground={link?.bg === "darkBg"}
			linkColor={isB2U && linkColor}
		>
			<div className={`user-details ${className}`} {...restProps}>
				{image?.image ? (
					<CloudinaryImage
						url={image.image}
						alt={image?.alt}
						quality="auto"
						fetchFormat="auto"
						lazyload
						sizes={{
							default: {
								width: 48,
							},
						}}
					></CloudinaryImage>
				) : null}
				<div className="text-container">
					<Text dark={isDarkBackground} variant="headline_6" tag="p">
						{title}
					</Text>
					<Text dark={isDarkBackground} variant="label_M">
						{subtitle}
					</Text>
				</div>
			</div>
			{coverImage?.image ? (
				<div className="cover-image">
					<CloudinaryImage
						url={coverImage.image}
						alt={coverImage?.alt}
						quality="auto"
						fetchFormat="auto"
						lazyload
					></CloudinaryImage>
				</div>
			) : null}
			<Text
				dark={isDarkBackground}
				className="description rich-text-wrapper"
				tag="div"
				variant="paragraph_S"
				dangerouslySetInnerHTML={{ __html: description }}
			/>
			{link?.text ? (
				<Link
					className="link"
					arrowCta
					href={link?.link?.link}
					target={link?.link?.target}
					onClick={(e) =>
						handleCTAClick(
							link,
							{
								page_section: pageSection,
								redirect_to: link?.link?.link,
								click_text: link?.text,
							},
							{},
							e,
						)
					}
					darkBg={isDarkBackground}
					linkText={link?.text}
				/>
			) : null}
		</PortfolioWrapper>
	);
};

Portfolio.defaultProps = {
	className: "",
	image: "",
	coverImage: "",
	title: "",
	subtitle: "",
	description: "",
	link: null,
	target: "",
	linkLabel: "",
	isDarkBackground: false,
	pageSection: "",
	linkColor: "var(--theme-light-font-color)",
};

Portfolio.propTypes = {
	className: PropTypes.string,
	image: PropTypes.object,
	coverImage: PropTypes.object,
	title: PropTypes.string,
	subtitle: PropTypes.string,
	description: PropTypes.string,
	link: PropTypes.object,
	target: PropTypes.string,
	isDarkBackground: PropTypes.bool,
	pageSection: PropTypes.string,
	linkColor: PropTypes.string,
};

export default Portfolio;
